// Job device passwords are encrypted at rest by the backend
// (pocketbase/pb_hooks/device-password.pb.js) and stored with this prefix.
// The frontend never decrypts locally — it asks the reveal endpoint with the
// master passcode. This helper only detects whether a value is ciphertext.

export const ENCRYPTED_DEVICE_PASSWORD_PREFIX = 'enc1:'

export function isEncryptedDevicePassword(value: string | null | undefined): boolean {
  return typeof value === 'string' && value.startsWith(ENCRYPTED_DEVICE_PASSWORD_PREFIX)
}
